module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("To my mother, to whom I dedicate everything I do. She lived to see all but the last chapter of this book. Never my best critic, she was always my best reader.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("By the rivers of Babylon, ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("We sat down and wept ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("When we remembered Zion.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-6",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("On the willows there ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-7",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("We hung up our harps.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter- ParaOverride-3",
    attrs: {
      "id": "_idParaDest-8",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("—Psalm 137")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-9",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("I wonder if I shall fall right through the earth!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-10",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("How funny it’ll seem to come out among the people that walk with their heads downward! ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-11",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("The Antipathies, I think—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter- ParaOverride-3",
    attrs: {
      "id": "_idParaDest-12",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("—Lewis Carroll, ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Alice’s Adventures in Wonderland")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09906526","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled235.vue
// module id = 66
// module chunks = 0